/**
* @Author: zachalam
* @Date:   2017-03-15T13:45:38-07:00
* @Email:  zach@reflexmedia.com
* @Last modified by:   zachalam
* @Last modified time: 2017-03-15T13:45:38-07:00
*/



import React, { Component } from 'react';
import Deactivate from '../components/pages/Settings/Deactivate';
import { connect } from 'react-redux';
import { deactivateAccount } from '../actions/authActions';

class DeactivateContainer extends Component {


  render() {
    return (
      <Deactivate {...this.props} />
    );
  }
}


const mapStateToProps = (state) => {
  return {
    errors: state.common.errors
  }
}

const mapDispatchToProps = (dispatch,ownProps) => {
  return {
    deactivate: (password) => {
      //console.log("deactivate");
      dispatch(deactivateAccount(password));
    }
  }
}
export default connect(mapStateToProps,mapDispatchToProps)(DeactivateContainer);



// WEBPACK FOOTER //
// ./src/containers/DeactivateContainer.jsx